import { useMutation, useQueryClient } from "@tanstack/react-query";

import keys from "./keys";
import { useApi } from "../client";

interface CreateClientVariables {
  // type?: string;
  name: string;
  // email: string;
  address: string;
  zipcode: string;
  region?: string;
  city: string;
  tel: string;
}

export const useCreateClient = () => {
  const api = useApi();
  const queryClient = useQueryClient();
  const queryKey = keys.all();

  return useMutation({
    mutationFn: async (variables: CreateClientVariables) => {
      const requestOptions = {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(variables),
      };
      const response = await api.post("clients", requestOptions);

      return response.json();
    },
    mutationKey: queryKey,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKey });
    },
    onError: () => {
      // toast.error("error");
    },
  });
};

interface UpdateClientVariables {
  type?: string;
  name?: string;
  email?: string;
  address?: string;
  zipcode?: string;
  region?: string;
  city?: string;
  tel?: string;
  areas?: {
    name: string;
    address: number;
    latitude: string;
    longitude: string;
    posts: {
      name: string;
      address: number;
      latitude: string;
      longitude: string;
    }[];
  }[];
}

export const useUpdateClient = (clientId: string) => {
  const api = useApi();
  const queryClient = useQueryClient();
  const queryKey = keys.all();

  return useMutation({
    mutationFn: async (client: UpdateClientVariables) => {
      const requestOptions = {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(client),
      };
      const response = await api.patch(`clients/${clientId}`, requestOptions);

      return response.json();
    },
    mutationKey: queryKey,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKey });
    },
    onError: () => {
      // toast.error("error");
    },
  });
};
